export const BILLING_METHOD_AUTO_CHARGE_TYPE = "auto_charge";
export const BILLING_METHOD_INVOICE_TYPE = "invoice";

export const BILLING_METHOD_TYPES = [
  BILLING_METHOD_AUTO_CHARGE_TYPE,
  BILLING_METHOD_INVOICE_TYPE,
] as const;
